import langConfig from './multi-lang.json';

const FormatDate = (date) => {
    const lang = navigator.language || navigator.userLanguage;
    const parsedDate = new Date(date);
    const newDate = new Intl.DateTimeFormat(lang, {year: "numeric", month: "long", day: "2-digit"}).format(parsedDate)
    
    return newDate
}

const FormatDateListView = date => {
  const lang = navigator.language || navigator.userLanguage;
  const parsedDate = new Date(date);
  
  const shortMonth = new Intl.DateTimeFormat(lang, {month: "short"}).format(parsedDate);
  const dayNumber = parsedDate.getDate();
  const fullYear = parsedDate.getFullYear();
  
  return {
    day: dayNumber,
    month: shortMonth.toUpperCase(),
    year: fullYear
  };
}

const TraslatorHelper = word => {
  const localLang = navigator.language || navigator.userLanguage;
  const appLang = localLang.substr(0, 2);
  
  try {

    return langConfig[appLang][word];
  } catch (error) {
    console.error(error);
    
    return '';
  }
}
const GenerateUUId = size => {
  const str = new Array(size + 1).join('x');

  return str.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8); // eslint-disable-line

    return v.toString(16);
  });
};

const ScrollToTop = () => {
  window.scrollTo(0, 0);
};

const ScrollSmooth = (top) => {
  window.scrollTo({top: top, behavior: 'smooth'});
};

// Thanks to! https://stackoverflow.com/a/46181
const ValidateEmail = (email) => {

  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const CreatePostTypePath = (category, postID) => {
  const rootBar = category.charAt(0) === '/' ? '' : '/'
  const link = `${rootBar}${category.toLowerCase()}/${postID}`

  return link;
};

const NavigatorLanguage = () => {
  const localLang = navigator.language || navigator.userLanguage;

  return localLang.substr(0, 2) || 'en';
}

export {
    FormatDate,
    FormatDateListView,
    TraslatorHelper,
    GenerateUUId,
    ScrollToTop,
    ScrollSmooth,
    ValidateEmail,
    CreatePostTypePath,
    NavigatorLanguage,
}